import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { BlogService } from '../../../services/blog.service';
import { ExternalpageService } from '../../../services/externalpage.service';
import { group_by_item_count } from '../../../../functions';

@Component({
  selector: 'app-home-blog-section',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, NgbCarouselModule],
  templateUrl: './home-blog-section.component.html',
})
export class HomeBlogSectionComponent {
  blogarticles: any[] = [];

  constructor(
    public blogService: BlogService,
    public externalpageService: ExternalpageService,
  ) {
    this.blogService.setHomeData();

    this.blogarticles = this.blogService.homeData;
    if (!this.blogarticles || this.blogarticles.length === 0) {
      this.blogService.$homeDataSubject.subscribe(() => {
        this.blogarticles = this.blogService.homeData;
        this.blogarticles = group_by_item_count(this.blogarticles, 3);
      });
    } else {
      this.blogarticles = group_by_item_count(this.blogarticles, 3);
    }
  }
}
